import { BasicsClass } from "@/common/BasicsClass";

export class SingleCardTransferRecordAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getSingleCardTranferRecordList', {
      url: '/shopMemberImport/index',
      name: 'list',
      label: '列表'
    }],


    ['getPreviewFileTable', {
      url: '/shopMemberImport/preview',
      name: 'upload-file-preview',
      label: '预览上传文档',
      // hidden: true
    }],

    ['importFileInfo', {
      url: '/shopMemberImport/import',
      name: 'import-file-info',
      label: '导入上传文件',
      // hidden: true
    }],
    
  ])
  // 订单api 方法
  // 会员卡移植记录列表
  public getSingleCardTranferRecordList(
    params: any,
    successCb: Function,
    failCb: Function,
    showLoading: boolean = false
  ) {

    console.log(params, "params");

    const apiUrls = this.apiUrls

    const url = apiUrls.get('getSingleCardTranferRecordList').url

    this.BasicPost(url, {
      ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 导入上传文件
  public getPreviewFileTable(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getPreviewFileTable').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // importFileInfo
  public importFileInfo(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('importFileInfo').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }
}
